const UUID_V4_LIKE_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isUUID(value?: string | null): value is string {
  if (!value) return false;
  return UUID_V4_LIKE_REGEX.test(value.trim());
}
